import { wechatShare } from "@/api/other.js";

const AUTH_QUERY = ["token", "hasMobile", "loginTicket"];

export function cleanShareLink(href = location.href) {
  const url = new URL(href, window.location.origin);
  AUTH_QUERY.forEach((key) => url.searchParams.delete(key));
  if (url.pathname === "/home" || url.pathname === "/home/") {
    url.searchParams.delete("code");
  }
  return url.toString();
}

export function getShareInfo(desc, icon) {
  let infoMap = {
    title: "宝贝爱蓝天精准捐衣",
    desc: desc ? desc : "宝贝爱蓝天精准捐衣",
    icon: icon ? icon : "http://h5.ademing.com/favicon.ico",
  };

  wechatShare({ url: location.href }).then(({ content }) => {
    wx.config({
      debug: false,
      appId: "wx9eea5352b0de031a",
      timestamp: content.timestamp,
      nonceStr: content.nonceStr,
      signature: content.signature,
      jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
    });
    wx.error(function (errres) {
      console.info("失败：", errres);
    });

    wx.ready(() => {
      console.info("ready");
      //需在用户可能点击分享按钮前就先调用
      //分享朋友
      wx.updateAppMessageShareData({
        title: infoMap.title, // 分享标题
        desc: infoMap.desc, // 分享描述
        link: cleanShareLink(), // 分享链接不带登录参数
        imgUrl: infoMap.icon, // 分享图标
        success: function () {
          console.info("成功");
          // 设置成功
        },
        fail: function (erres) {
          console.info("失败：", erres);
        },
      });
      //分享到 朋友圈
      wx.updateTimelineShareData({
        title: infoMap.title, // 分享标题
        link: cleanShareLink(),
        imgUrl: infoMap.icon, // 分享图标
        success: function () {
          console.info("成功");
          // 设置成功
        },
        fail: function (erres) {
          console.info("失败：", erres);
        },
      });
    });
  });
}
